import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import get from 'lodash/get';
import moment from 'moment';
import utils from '@utils';
import { JOB_TYPES } from '@utils/constants';

class DateFormatter extends Component {
	shouldComponentUpdate = ({ row, timeZone, jobType }) => {
		const { StartDateTime, EndDateTime, ApplicantsNeeded } = row;
		const lastProps = this.props;

		return (
			!isEqual(StartDateTime, lastProps.row.StartDateTime)
			|| !isEqual(EndDateTime, lastProps.row.EndDateTime)
			|| !isEqual(ApplicantsNeeded, lastProps.row.ApplicantsNeeded)
			|| !isEqual(timeZone, lastProps.timeZone)
			|| !isEqual(jobType, lastProps.jobType)
		);
	}

	parseDate = (start, end, timeZone) => {
		const parsedStartDate = utils.parseUTCDateToTimeZone(start, timeZone);
		const parsedEndDate = utils.parseUTCDateToTimeZone(end, timeZone);
		let diff = 0;
		const { jobType } = this.props;

		if (jobType === 2) {
			const startDate = moment(start).startOf('day');
			const today = moment().startOf('day');
			diff = startDate.diff(today, 'days');
		}

		return {
			startDate : parsedStartDate.format('MMMM DD, YYYY'),
			startTime : parsedStartDate.format('hh:mm A'),
			endDate   : parsedEndDate.format('MMMM DD, YYYY'),
			endTime   : parsedEndDate.format('hh:mm A'),
			diff,
		};
	}

	render() {
		const { row, timeZone, jobType } = this.props;
		const { StartDateTime, EndDateTime, ApplicantsNeeded } = row;
		const {
			startDate, startTime, endTime, diff,
		} = this.parseDate(StartDateTime, EndDateTime, timeZone);

		const clockInTime = get(row, 'Jobs[0].AssignedOfficers[0].ClockIn');
		const clockOutTime = get(row, 'Jobs[0].AssignedOfficers[0].ClockOut');

		return (
			<div className="date-formatter">
				<h5>{ startDate }</h5>
				<div className="job-time">
					<span><i className="rkfm rkfm-clock" /></span>
					<span>
						{ startTime }
						{' '}
						-
						{' '}
						{ endTime }
					</span>
				</div>
				<Choose>
					<When condition={jobType === JOB_TYPES.upcoming.type}>
						<div className="date-detail date-detail--upcoming">
							<span>
								Starts in
								{' '}
								{ diff }
								{' '}
								{ diff === 1 ? 'day' : 'days' }
							</span>
						</div>
					</When>
					<When condition={ApplicantsNeeded === 1}>
						<div className="date-detail">
							<div>
								<span>Clock-In</span>
								<span>
									{ clockInTime ? utils.parseUTCDateToTimeZone(clockInTime, timeZone).format('h:mm A') : '--' }
								</span>
							</div>
							<div>
								<span>Clock-Out</span>
								<span>
									{ clockOutTime ? utils.parseUTCDateToTimeZone(clockOutTime, timeZone).format('h:mm A') : '--' }
								</span>
							</div>
						</div>
					</When>
				</Choose>
			</div>
		);
	}
}

DateFormatter.propTypes = {
	jobType  : PropTypes.number,
	row      : PropTypes.object.isRequired,
	timeZone : PropTypes.string,
};

DateFormatter.defaultProps = {
	jobType  : 0,
	timeZone : '',
};

export default DateFormatter;
